<template>
  <section class="container">
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="mt-0 pt-0">
        <h4>Projects/Jobs</h4>

        <div class="d-flex flex-row">
          <v-divider color="black"></v-divider>
        </div>
      </v-col>
      <v-col cols="6"></v-col>
    </v-row>
    <v-container class="grey lighten-5">
      <v-row no-gutters>
        <v-col v-for="n in 3" :key="n" cols="12" sm="4">
          <v-card color="grey lighten-4 margin-rt">
            <div class="d-flex flex-row justify-space-between">
              <strong class="ml-2 mt-1">ABC Project</strong>
            </div>
            <div class="d-flex flex-row ml-2">Contractor Name</div>

            <div class="d-flex flex-row ml-2 margin-tp">111 Wall Street</div>

            <div class="d-flex flex-row ml-2">
              <div class="mt-5">
                <v-btn
                  color="blue"
                  style="color: white"
                  class="mr-2 mb-2"
                  small
                  to="/projectList/projectListDetails"
                  >View
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      sideNav: false,
      menuItems: []
    };
  },
  mounted() {
    console.log("App Component mounted.");
  }
};
</script>

<style scoped>
.v-tab--active {
  color: inherit;
  background-color: #222020 !important;
}
.margin-tp {
  margin-top: 7px;
}
.margin-rt {
  margin-right: 5px;
}
</style>
